import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { toast } from 'react-hot-toast';

type DeletePublicationOrgParams = {
  languageId: number;
  organizationId: number | string;
};

export const useDeletePublicationOrganization = () => {
  const queryClient = useQueryClient();

  const deletePublicationOrg = async ({
    languageId,
    organizationId
  }: DeletePublicationOrgParams) => {
    const url = DELETE_URL(
      languageId.toString(),
      organizationId.toString()
    ).deleteLanguageConfigPublication;

    const { data } = await Axios.delete(url);
    return data;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<any, AxiosError<BaseError>, DeletePublicationOrgParams>(
    deletePublicationOrg,
    {
      onSuccess: (_data, vars) => {
        queryClient.invalidateQueries([
          'languageAndConfigPublication',
          vars.languageId
        ]);
      },
      onError: err => {
        const msg =
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (err.response?.data as any)?.error_description ||
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (err.response?.data as any)?.message ||
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (err.response?.data as any)?.error ||
          err.message ||
          'Failed to delete publication';
        toast.error(msg);
      },
      useErrorBoundary: false
    }
  );
};
